import { useNavigate } from "react-router-dom"

import Style from "./style"
import pageArrow from "./asset/page_arrow.svg"

import PageTitle from "widget/PageTitle"
import Pagenation from "widget/Pagenation"

import useGetAccountEventRecord from "entity/account/useGetAccountEventRecord"

import timestampCalculator from "shared/lib/timestampCalculator"
import { convertEventTypeAsName } from "shared/constant/lookup/eventType"

const MyEventRecord = () => {
    const navigate = useNavigate()

    const [getEventRecord] = useGetAccountEventRecord()

    return (
        <Style.Wrapper>
            <PageTitle>내 대회 기록</PageTitle>

            <Style.RecordList>
                {getEventRecord?.data?.event_record?.map(elem =>
                    <div>
                        <Style.RecordElement>
                            <div>
                                <h2>{elem?.event_name}</h2>
                                <p>{timestampCalculator(elem?.event_date)}</p>
                                <p>{convertEventTypeAsName[elem?.event_type_flag]}</p>
                                <p>{elem?.rank ? `${elem?.rank}위` : "순위권 외"} {elem?.score && <span>+{elem?.score}PR</span>}</p>
                            </div>
                            <button onClick={() => navigate(`/event/${elem.event_idx}/detail`)}>
                                <p>상세보기</p>
                                <img src={pageArrow} />
                            </button>
                        </Style.RecordElement>
                    </div>
                )}
                {getEventRecord?.data?.event_record?.length < 1 && <Style.Option>대회 기록이 없습니다.</Style.Option>}
            </Style.RecordList>

            <Pagenation maxPage={getEventRecord?.data?.max_page} />

        </Style.Wrapper >
    )
}

export default MyEventRecord